var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignsinprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#163E6E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_3943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 9.0625C20.6445 9.0625 17.8532 9.90924 15.479 11.4957C13.1047 13.0821 11.2542 15.3369 10.1615 17.975C9.06876 20.6131 8.78284 23.516 9.33992 26.3166C9.89699 29.1172 11.272 31.6897 13.2912 33.7089C15.3103 35.728 17.8828 37.103 20.6834 37.6601C23.484 38.2172 26.3869 37.9312 29.025 36.8385C31.6631 35.7458 33.9179 33.8953 35.5043 31.521C37.0908 29.1468 37.9375 26.3555 37.9375 23.5C37.9332 19.6723 36.4107 16.0025 33.7041 13.2959C30.9975 10.5893 27.3277 9.06681 23.5 9.0625ZM23.5 35.875C20.218 35.875 17.0703 34.5712 14.7496 32.2504C12.4288 29.9297 11.125 26.7821 11.125 23.5C11.125 20.2179 12.4288 17.0703 14.7496 14.7496C17.0703 12.4288 20.218 11.125 23.5 11.125V23.5L32.2462 32.2464C31.0992 33.3975 29.7361 34.3106 28.2351 34.9333C26.7342 35.556 25.125 35.876 23.5 35.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_3943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignsinprogress);
export default __webpack_public_path__ + "static/media/campaignsinprogress.c56e126155fe2ee213ef3738fd7573bd.svg";
export { ForwardRef as ReactComponent };